import DialogButton, { type DialogButtonProps } from './DialogButton';
import { FormattedMessage } from 'react-intl';

const DialogSaveButton = ({ children, ...props }: DialogButtonProps) => (
  <DialogButton color="primary" {...props}>
    {children ?? <FormattedMessage id="dialogs.actions.save" />}
  </DialogButton>
);

export default DialogSaveButton;
